<template>
    <div class="row">
        <div class="col-12 mb-1" v-for="(v,i) in value.ManualVariableValues">
            <label class="form-label">{{ v.Name }}</label>
            <v-date-picker v-if="v.DataType == 'date'" v-model="value.ManualVariableValues[i].Value" :placeholder="v.Name"></v-date-picker>
            <input class="form-control" v-else-if="v.DataType == 'string'" v-model="value.ManualVariableValues[i].Value" :placeholder="v.Name"/>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        value:Object
    }
}
</script>